// extracted by mini-css-extract-plugin
export var teleformContainer = "teleformulaire-module--teleform-container--bcd17";
export var teleformFooter = "teleformulaire-module--teleform-footer--9cda6";
export var teleformLibre = "teleformulaire-module--teleform-libre--d3a55";
export var teleformLinks = "teleformulaire-module--teleform-links--dc21f";
export var teleformLinksItem = "teleformulaire-module--teleform-links-item--65f24";
export var teleformLinksItemTitle = "teleformulaire-module--teleform-links-item-title--4badd";
export var teleformLinksList = "teleformulaire-module--teleform-links-list--b5345";
export var teleformLinksTitle = "teleformulaire-module--teleform-links-title--52148";
export var teleformTaxo = "teleformulaire-module--teleform-taxo--81cc5";
export var teleformTaxoItem = "teleformulaire-module--teleform-taxo-item--62df0";
export var teleformTitle = "teleformulaire-module--teleform-title--9686f";
export var teleformulaire = "teleformulaire-module--teleformulaire--f4ea7";